export default __webpack_public_path__ + "images/542fec493f093cb39b6e1610cad9ff9a-4_mobile_659x494.jpg";